import React from "react";
import PropTypes from "prop-types";
import BaseBlock from "./BaseBlock";
import useBlockData from "./useBlockData";
import ForecastBandChart from "../charts/ForecastBandChart";

/**
 * ForecastBandBlock - actual-vs-forecast trend with a shaded 90% confidence band
 * (forecast_band block type).
 *
 * GET /api/v1/board-reports/{boardReportId}/runs/{runId}/figures/forecast-band -> envelope
 * key "forecast_band" -> boardfigures.ForecastBand { points: [BandPoint] } (Task 5's
 * BuildForecastBand). Rendering (line/band layout, empty state) is entirely
 * ForecastBandChart's job (Task 12) - this block only fetches and unwraps the envelope,
 * mirroring StackedTrendBlock/VarianceWaterfallBlock's fetch pattern.
 */
const ForecastBandBlock = ({ title = "Forecast", boardReportId, runId }) => {
  const { data, isLoading, error } = useBlockData(
    `/api/v1/board-reports/${boardReportId}/runs/${runId}/figures/forecast-band`
  );

  const points = data?.forecast_band?.points ?? [];

  return (
    <BaseBlock title={title} isLoading={isLoading} error={error} className="a4-forecast-band">
      <ForecastBandChart points={points} />
    </BaseBlock>
  );
};

ForecastBandBlock.propTypes = {
  title: PropTypes.string,
  boardReportId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  runId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default ForecastBandBlock;
